(function () {
	'use strict';

	angular.module('configureSupplierPerformanceModule', ['ui.bootstrap', 'ui.select', 'pascalprecht.translate', 'angularutilities', 'smarttableutilities'])
		.service('configureSupplierPerformanceService', ConfigureSupplierPerformanceService)
		.controller('configureSupplierPerformanceCtrl', ConfigureSupplierPerformanceCtrl);

	function ConfigureSupplierPerformanceService($http) {

		var urlPfx = '/api/2/factndx/{0}/';
		return {
			getSettings: getSettings,
			updateSettings: updateSettings
		};

		function getSettings(siteId) {
			var url = String.format(urlPfx, siteId || globalConfig.factory.id) + 'SupplierPerformanceSettings';
			return $http.get(url)
				.then(getSettingsComplete)
				.catch(getSettingsFailed);
			function getSettingsComplete(response) {
				return response;
			}
			function getSettingsFailed(error) {
				return error;
			}
		}

		function updateSettings(settings, dateModified, siteId) {
			var url = String.format(urlPfx, siteId || globalConfig.factory.id) + 'SupplierPerformanceSettings';
			var req = {
				method: 'PUT',
				url: url,
				data: settings,
				headers: {
					'If-Unmodified-Since': dateModified
				}
			};
			return $http(req)
				.then(updateSettingsComplete)
				.catch(updateSettingsFailed);
			function updateSettingsComplete(response) {
				return null;
			}
			function updateSettingsFailed(error) {
				return error;
			}
		}
	}

	function ConfigureSupplierPerformanceCtrl($scope, $rootScope, $timeout, $location, $uibPosition, $sce, configureSupplierPerformanceService, storeService, $experiments) {
		var adminConfig = storeService.getState().adminConfig;
		$scope.title = 'Configure Supplier Performance';
		var isLeanDNAAdmin = $rootScope.authz && $rootScope.authz.isLeanDNAAdmin();
		$scope.deliveryScoreComputationMethods = [
			{ name: 'Quantity Delivered', value: 'quantity' },
			{ name: 'Number of Deliveries', value: 'count' },
			{ name: 'Value Delivered', value: 'value' }
		];

		$scope.monthUsedToGroupDeliveryScore = [
			{ value: 'Month of delivery'},
			{ value: 'Month of expected, requested or commit date'}
		];

		$scope.dateTypes = [
			{name: 'Requested Date', value: 'originalRequestedDate'},
			{name: 'Expected Delivery Date', value: 'requestedDate'},
			{name: 'Current Supplier Commit Date', value: 'promiseDate'}
		];
		// Build scorecard fields array, conditionally including Quality for lean DNA admins only
		$scope.scorecardFields = ['Delivery', 'Early Delivery', 'Late Delivery', 'VMI Over Max', 'VMI Under Min']
			.concat(isLeanDNAAdmin ? ['Quality'] : [])
			.concat(['Cost']);
		$scope.settings = {};
		$scope.selected = {};
		$scope.selected.reportFields = [];
		$scope.selected.emailFields = [];
		$scope.pageLoaded = false;
		$scope.customerName = adminConfig.customer.name;
		
		// Make authz service available to the template
		$scope.authz = $rootScope.authz;

		// scope functions
		$scope.clearToast = clearToast;
		$scope.clearErrorMessage = clearErrorMessage;
		$scope.submit = submit;
		
		$scope.open = function() {
			$timeout(function() {
				$scope.opened = true;
			});
		};
		
		$timeout(function(){
			jQuery('#configureSupplierPerformance').addClass('selected');
			init();
		}, 0);

		function init() {
			getData();
		}

		function clearToast() {
			$scope.toastMessage = undefined;
		}

		function getData() {
			configureSupplierPerformanceService.getSettings(adminConfig.factory.id)
					.then(initForm);
		}

		function updateDisplayOptionsDropdowns() {
			$scope.selected.reportFields = [];
			$scope.selected.emailFields = [];
			if ($scope.settings.showCostInReport === true) {
				$scope.selected.reportFields.push('Cost');
			}
			if ($scope.settings.showQualityInReport === true && isLeanDNAAdmin) {
				$scope.selected.reportFields.push('Quality');
			}
			if ($scope.settings.showDeliveryInReport === true) {
				$scope.selected.reportFields.push('Delivery');
			}
			if ($scope.settings.showEarlyDeliveryInReport === true) {
				$scope.selected.reportFields.push('Early Delivery');
			}
			if ($scope.settings.showLateDeliveryInReport === true) {
				$scope.selected.reportFields.push('Late Delivery');
			}
			if ($scope.settings.showVmiOverMaxInReport === true) {
				$scope.selected.reportFields.push('VMI Over Max');
			}
			if ($scope.settings.showVmiUnderMinInReport === true) {
				$scope.selected.reportFields.push('VMI Under Min');
			}
			if ($scope.settings.showCostInEmail === true) {
				$scope.selected.emailFields.push('Cost');
			}
			if ($scope.settings.showQualityInEmail === true && isLeanDNAAdmin) {
				$scope.selected.emailFields.push('Quality');
			}
			if ($scope.settings.showDeliveryInEmail === true) {
				$scope.selected.emailFields.push('Delivery');
			}
			if ($scope.settings.showEarlyDeliveryInEmail === true) {
				$scope.selected.emailFields.push('Early Delivery');
			}
			if ($scope.settings.showLateDeliveryInEmail === true) {
				$scope.selected.emailFields.push('Late Delivery');
			}
			if ($scope.settings.showVmiOverMaxInEmail === true) {
				$scope.selected.emailFields.push('VMI Over Max');
			}
			if ($scope.settings.showVmiUnderMinInEmail === true) {
				$scope.selected.emailFields.push('VMI Under Min');
			}
		}
		
		function updateSettingsFromReportFieldsDropdowns() {
			$scope.settings.showCostInReport = $scope.settings.showQualityInReport = $scope.settings.showDeliveryInReport = $scope.settings.showLateDeliveryInReport
				=  $scope.settings.showEarlyDeliveryInReport = $scope.settings.showVmiOverMaxInReport = $scope.settings.showVmiUnderMinInReport = false;
			if (typeof $scope.selected.reportFields !== 'undefined') {
				for (var i=0; i < $scope.selected.reportFields.length; i++) {
					switch ($scope.selected.reportFields[i]) {
					case 'Cost': $scope.settings.showCostInReport = true;
						break;
					case 'Quality': 
						if ($rootScope.authz && isLeanDNAAdmin) {
							$scope.settings.showQualityInReport = true;
						}
						break;
					case 'Delivery': $scope.settings.showDeliveryInReport = true;
						break;
					case 'Late Delivery': $scope.settings.showLateDeliveryInReport = true;
						break;
					case 'Early Delivery': $scope.settings.showEarlyDeliveryInReport = true;
						break;
					case 'VMI Over Max': $scope.settings.showVmiOverMaxInReport = true;
						break;
					case 'VMI Under Min': $scope.settings.showVmiUnderMinInReport = true;
						break;
					default:
							// Shouldn't happen
					}
				}
			}
			$scope.settings.showCostInEmail = $scope.settings.showQualityInEmail = $scope.settings.showDeliveryInEmail = $scope.settings.showLateDeliveryInEmail
				=  $scope.settings.showEarlyDeliveryInEmail = $scope.settings.showVmiOverMaxInEmail = $scope.settings.showVmiUnderMinInEmail = false;
			if (typeof $scope.selected.emailFields !== 'undefined') {
				for (var i=0; i < $scope.selected.emailFields.length; i++) {
					switch ($scope.selected.emailFields[i]) {
					case 'Cost': $scope.settings.showCostInEmail = true;
						break;
					case 'Quality': 
						if ($rootScope.authz && isLeanDNAAdmin) {
							$scope.settings.showQualityInEmail = true;
						}
						break;
					case 'Delivery': $scope.settings.showDeliveryInEmail = true;
						break;
					case 'Late Delivery': $scope.settings.showLateDeliveryInEmail = true;
						break;
					case 'Early Delivery': $scope.settings.showEarlyDeliveryInEmail = true;
						break;
					case 'VMI Over Max': $scope.settings.showVmiOverMaxInEmail = true;
						break;
					case 'VMI Under Min': $scope.settings.showVmiUnderMinInEmail = true;
						break;
					default:
							// Shouldn't happen
					} 
				}
			}
		}
		
		function initForm(response) {
			$scope.settings = response.data;
			// Convert date to a javascript Date object, otherwise datepicker doesn't work properly
			$scope.settings.startDate = new Date(response.data.startDate);
			updateDisplayOptionsDropdowns();
			$scope.dateModified = response.headers('Last-Modified');
			$scope.pageLoaded = true;
		}

		function clearErrorMessage() {
			$scope.errorMessage = '';
		}

		function submit() {
			updateSettingsFromReportFieldsDropdowns();
			configureSupplierPerformanceService.updateSettings($scope.settings, $scope.dateModified, adminConfig.factory.id)
					.then(handleResponse);
			
			function handleResponse(response) {
				if (response === null) {
					$scope.toastMessage = 'Settings updated successfully';
					$timeout(function(){ $scope.toastMessage = ''; }, 3000);
				} else {
					$scope.errorMessage = response.data.error;
					$timeout(function() {
						$scope.errorMessage = '';
					}, 5000);
				}
			}
		}
	}
})();
